/**
 * Helper
 */
var helper = require('../../helper'),
        dataTables_columns_export = [
            {data: 'company_contact', name:'clientContact.fullName', title: 'Company contact', orderable: false, searchable: true, visible: false},
            {data: 'price_from', name:'price_from', title: 'Price from', orderable: false, searchable: true, visible: false},
            {data: 'price_to', name:'price_to', title: 'Price to', orderable: false, searchable: true, visible: false},
            {data: 'spaces', name:'spaces', title: 'Spaces', orderable: false, searchable: true, visible: false},
            {data: 'bathrooms', name:'bathrooms', title: 'Bathrooms', orderable: false, searchable: true, visible: false},
            {data: 'kitchens', name:'kitchens', title: 'Kitchens', orderable: false, searchable: true, visible: false},
            {data: 'garden', name:'garden', title: 'Gardens', orderable: false, searchable: true, visible: false},
            {data: 'parking', name:'parking', title: 'Parking', orderable: false, searchable: true, visible: false},
            {data: 'vip_amount', name:'vip_amount', title: 'VIP amount', orderable: false, searchable: true, visible: false},
            {data: 'vip_provided', name:'vip_provided', title: 'VIP provided', orderable: false, searchable: true, visible: false},
            {data: 'savings_made', name:'savings_made', title: 'Savings made', orderable: false, searchable: true, visible: false},
            {data: 'date_taken_on', name:'date_taken_on', title: 'Date taken on', orderable: false, searchable: true, visible: false},
            {data: 'date_live', name:'date_live', title: 'Date live', type: "date-uk", orderable: false, searchable: true, visible: false},
            {data: 'date_taken_back', name:'date_taken_back', title: 'Date taken back', orderable: false, searchable: true, visible: false},
            {data: 'short_description', name:'short_description', title: 'Description', orderable: false, searchable: true, visible: false},
            {data: 'address', name:'address', title: 'Address', orderable: false, searchable: true, visible: false},
            {data: 'town', name:'town', title: 'Town', orderable: false, searchable: true, visible: false},
	        {data: 'latitude', name:'latitude', title: 'Latitude', orderable: true, searchable: true, visible: false},
	        {data: 'longitude', name:'longitude', title: 'Latitude', orderable: true, searchable: true, visible: false},
            {data: 'client_type', name:'client_type', title: 'Client type', orderable: false, searchable: true, visible: false},
        ];


$(function() {
    var $datatable = $('#datatable-all-properties-read-only'),
        $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/properties/contractors-read-only",
            "method": 'POST',
            "data": function ( d ) {
               d.status_id = $('input[name="clickedStatusId"]').val();
            }
        },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columnDefs": [
            { "type": "date-uk", targets: 17 }, // not work
        ],
        "columns": [
            {data: 'property_name', name: 'name'},
            {data: 'property_id', name: 'property_id'},
            {data: 'postcode', name: 'postcode'},
            {data: 'status', name: 'status', orderable: false, searchable: false,},
	        {data: 'date_notice', name:'date_notice', title: 'Notice date', type: "date-uk", orderable: false, searchable: true },
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action"}
        ].concat(dataTables_columns_export),
        "initComplete": function(settings, json) {
            // init callback
        }
    });

    $('.js-property-activity-box').on('click', function() {
        var $this = $(this),
            $clickedStatusId = $('input[name="clickedStatusId"]'),
            statusId = $(this).data('status_id');

        $clickedStatusId.val(statusId);

        var valueToDisplay = $(this).children('.activity-title').data('to_display');
        $('#property-status-span').text( 'Properties of ' + valueToDisplay + ' status' );
        $dt.ajax.reload();
    });

});
